<template>
  <div>
    <component v-bind:is="headerComponent"></component>
    <div class="content row-container">
      <div class="content__aside">
        <component v-bind:is="sidebarComponent"></component>
      </div>
      <div class="content__main">
        <component name="billing-support" v-bind:is="articlesComponent"></component>
      </div>
    </div>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent, trackPageView } from '@/utils/common'

export default {
  name: 'account_support',
  created() {
    trackPageView('announcements')
  },
  computed: {
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header')
    },
    sidebarComponent() {
      return getComponent(this.$store.getters.flowObject, 'sidebar')
    },
    articlesComponent() {
      return getComponent(this.$store.getters.flowObject, 'articles')
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer')
    }
  }
}
</script>
<style scoped>
  * {
    font-family: 'Source Sans Pro',Arial, Helvetica, sans-serif!important;
    color:#fff!important;
  }

  html, body {
    background-color: #fbfbfb;
  }

  a {
    color: #F04682!important;
  }

  a:hover {
    border-color: #F04682!important;
  }


  .sidebar .icon .polygon{
    fill: #F04682!important;
  }
  .sidebar a { color:#F04682!important;}
  .sidebar span { color:#F04682!important;}
  .input-group--search{
    background-color: transparent!important;
  }


  .input-group--search .input {
    border-radius: 5px;
    background-color: #ffffff;
    color:#101218!important;
    border: 1px solid rgba($color: #ffffff, $alpha: 0.1)!important;
    padding-left: 45px!important;
  }

  .input-group--search .input::placeholder { color: rgba($color: #101218, $alpha: 0.5)!important;}
  .autocomplete-results {background-color: #31343E!important; border-color: rgba($color: #ffffff, $alpha: 0.1)!important;}

  .input-group--search .icon {
    background-color: transparent!important;
    float: left!important;
    display: inline-block;
    left:1rem!important;
    top: 66%!important;
  }

  .category-boxes__item__link a, .category-boxes__item__link h3, .category-boxes__item__link p {
    color:#101218!important;
  }

  .category-boxes__item__link p { font-weight: 500;}

  .category-boxes__item__link:hover {
    background-color:#fff!important;
    color:#101218!important;
  }

  .category-boxes__item__link:hover * {
    color:#101218!important;
  }


  .category-boxes__item__link .icon polygon, .category-boxes__item__link .icon path {
    fill: #F04682!important;
  }


  .language-dropdown__list .text, .language-dropdown__list .link { color:#101218!important; }

  .ma0 { font-weight: 700; }
  .stage__text .link { font-weight: 600;}

  .content__main { padding:20px!important; border-radius: 5px; background-color: #ffffff; color:#101218!important; border: 1px solid #eeeeee;}
  .articles .title { color:#101218!important; }
  .content__main h1 { color:#101218!important; }
  .article-body, .article-body * { color:#101218!important; font-weight: 600;}
  .content__aside .sidebar__links { background-color: #fff; border: 1px solid #eeeeee; border-radius: 5px; position: relative; top:-50px;}
  .footer__modal-option a { font-weight: 600!important;}
  .footer__modal-link { border-radius: 5px; }

  .article-body, .article-body a { color:#F04682!important;}

  .row-container * { color:#101218!important}
  .row-container a { color:#F04682!important}
  .stage__text .stage__text__question { color:#fff!important; }
  .input-group--btns { margin: 5px 0 20px!important; padding:0!important}
  .input-group--btns button {background-color: #F04682!important; color:#fff!important; font-weight: 600!important;}
</style>
